import { Controller } from "@hotwired/stimulus"

/**
 * Surcharge Toggle Controller
 * Shows/hides the work time category and percentage fields when surcharge checkbox is toggled
 */
export default class extends Controller {
  static targets = ["checkbox", "fields"]

  connect() {
    // Set initial state based on checkbox
    this.toggle()
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.fieldsTarget.classList.remove("hidden")
      this.fieldsTarget.classList.add("flex", "items-center", "space-x-2")
    } else {
      this.fieldsTarget.classList.add("hidden")
      this.fieldsTarget.classList.remove("flex", "items-center", "space-x-2")
    }
  }
}
